/* global window, videojs */

function insertAdMarkers(encore) {
  if (encore.source.isLiveStream) {
    return;
  }

  const currentMarkers = encore.player.markers.getMarkers();
  if (currentMarkers.length) {
    videojs.log(`${encore.playerElementId} Skipping ad markers [${currentMarkers.length}]`);
    return;
  }

  const adsManager = encore.player.ima.getAdsManager();
  if (!adsManager) {
    return;
  }

  const cuePoints = adsManager.getCuePoints();
  if (!cuePoints.length) {
    return;
  }

  videojs.log(`${encore.playerElementId} Found [${cuePoints.length}] cue points`);

  const newMarkers = cuePoints.map(cuePoint => ({
    time: cuePoint === -1 ? encore.player.duration() : cuePoint,
    text: 'Ad',
  }));

  const noPreRoll = newMarkers.filter(marker => marker.time !== 0);
  encore.player.markers.add(noPreRoll);
  videojs.log(`${encore.playerElementId} Adding [${noPreRoll.length}] ad markers`);
}

/**
 * Attach ad markers events to video player.
 * @param {Object} Encore - Encore video player instance.
 */
function attachAdMarkersEvents(encore) {
  encore.player.one('ads-ima-adCanPlay', insertAdMarkers.bind(this, encore));
  encore.player.one('played-q0', insertAdMarkers.bind(this, encore));

  encore.player.on('ads-ima-complete', () => {
    const currentMarkers = encore.player.markers.getMarkers();
    if (!currentMarkers.length) {
      return;
    }

    const markersToRemove = [];
    for (let i = 0; i < currentMarkers.length; i++) {
      if (encore.player.currentTime() > currentMarkers[i].time) {
        markersToRemove.push(i);
      }
    }
    encore.player.markers.remove(markersToRemove);
    videojs.log(`${encore.playerElementId} Removing [${markersToRemove.length}] ad markers`);
  });

  encore.player.on('ads-ima-allAdsCompleted', () => {
    encore.player.markers.removeAll();
  });
}

export default attachAdMarkersEvents;



// WEBPACK FOOTER //
// ./src/adMarkers.js